import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
export function withPane(props, context) {
  var _props$pane;
  var pane = (_props$pane = props.pane) != null ? _props$pane : context.pane;
  return pane ? _objectSpread({}, props, {
    pane: pane
  }) : props;
}